function CollapseNavbarIcon() {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path d="M1 5H15V7H1V5Z" fill="#000000"></path>{" "}
        <path d="M1 9H15V11H1V9Z" fill="#000000"></path>{" "}
        <path d="M1 13H15V15H1V13Z" fill="#000000"></path>{" "}
        <path d="M1 1H15V3H1V1Z" fill="#000000"></path>{" "}
      </g>
    </svg>
  );
}

export { CollapseNavbarIcon };
